import { styled } from "@mui/material/styles";
import { Grid, Button as MuiButton } from "@mui/material";

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: "15px",
  minWidth: "330px",
  height: "100%",
  justifyContent: "space-evenly",
  marginRight: "12px",
}));

export const ClockAndButtonsContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  justifyContent: "space-around",
}));

export const ClockContainer = styled(Grid)({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  // marginBottom: "40px",
});

export const Clock = styled(Grid)({
  ".MuiTypography-root": {
    lineHeight: "1.1",
  },
});

export const Buttons = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  gap: "5px",
});

export const Button = styled(MuiButton)({
  padding: "2px 16px",
  textTransform: "none",
});

export const ClockingListsContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
});
